import React from "react";

export default function AccountSection({ children }) {
  return (
    <div className="text-lg font-bold text-[#2d348f] mb-4 mt-2">{children}</div>
  );
}
